import { useRef } from "react";

/**
 * The latest non-null `value`, kept after it goes back to null. Lets a modal keep showing its row while it
 * animates closed instead of emptying first.
 */
export function useRetained<T>(value: T | null | undefined): T | null {
  const last = useRef<T | null>(null);
  if (value != null) last.current = value;
  return last.current;
}
